const SprintProjectsReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_SPRINT_PROJECTS':
            return action.data;
        default:
            return state;
    };
};

export default SprintProjectsReducer;